import { getLabel } from '../InitData';
import { usePrematchData } from './PrematchDataFetcher';
import { livePrefix, prematchPrefix } from '../Container';
import { ErrorBoundary } from '../common/ErrorBoundary';
import ErrorMessageWithLink from '../common/ErrorMessageWithLink';
import TopCompetitions from '../common/TopCompetitions';
import LeftSidebar from '../common/left-sidebar/LeftSidebar';
import SidebarLink from '../common/left-sidebar/SidebarLink';
import CollapseMenu from '../common/menu/CollapseMenu';
import RightSidebar from '../common/right-sidebar/RightSidebar';
import SearchResults from '../common/search/SearchResults';
import Outlet from '../router/Outlet';
import Menu from './Menu';
import LastMinute from '../common/right-sidebar/LastMinute';
import BottomBanners from '../common/right-sidebar/BottomBanners';

export function getAllLink(isLive) {
    if (isLive) {
        return livePrefix;
    }

    return prematchPrefix;
}

export default function PrematchWrapper(props) {
    const prematchData = usePrematchData();

    return (
        <div className="c_8">
            <LeftSidebar>
                <SearchResults />
                <TopCompetitions />
                <CollapseMenu title={getLabel('general.sports')} info={prematchData.eventsCount}>
                    <SidebarLink href={`${prematchPrefix}/favorites`} icon={'Favs_default.svg'} text={getLabel('general.favorites')} info={null} />
                    <SidebarLink href={getAllLink()} icon={'icon_allsports.svg'} text={getLabel('general.all_sports')} info={null} />
                    <SidebarLink href={`${prematchPrefix}/daily-flash-odds`} icon={'daily_flash_odds.svg'} text={getLabel('daily_flash_odds')} />
                    <Menu sports={props.sports || prematchData.sport} />
                </CollapseMenu>
            </LeftSidebar>
            <ErrorBoundary fallback={<ErrorMessageWithLink />}>
                <Outlet />
            </ErrorBoundary>
            <RightSidebar>
                <LastMinute />
                <BottomBanners />
            </RightSidebar>
        </div>
    );
}
